import { createSlice } from '@reduxjs/toolkit';

const initialState: { groupView: string } = {
    groupView: ''
};

const groupViewSlice = createSlice({
    name: 'groupView',
    initialState,
    reducers: {
        setGroupView(state, action) {
            state.groupView = action.payload;
        }
    }
});

export const { setGroupView } = groupViewSlice.actions;
export default groupViewSlice.reducer;
